export default __webpack_public_path__ + "static/media/logo.122ba7fb.svg";